import * as auth from "./auth";
import * as db from "./db";
import * as firebase from "./firebase";
import { storage, functions } from "./firebase";

const fbroot = firebase.fbroot;

export { auth, db, firebase, storage, functions, fbroot };
